import React, { ReactElement } from 'react';
import { CommonLayoutPropsOption } from '@/types/other';

const withCommonLayoutProps = (
  page: ReactElement,
  props: CommonLayoutPropsOption,
  LayoutProp: React.ComponentType<CommonLayoutPropsOption>
) => {
  const {
    windowWidthSv = null,
    user,
    recentlySignedIn,
    recentlySignedUp,
    shouldShowKlaviyo,
    browserLocale,
    sessionToken,
    isStaticPage,
  } = props;

  return (
    <LayoutProp
      windowWidthSv={windowWidthSv}
      user={user}
      recentlySignedIn={recentlySignedIn}
      recentlySignedUp={recentlySignedUp}
      shouldShowKlaviyo={shouldShowKlaviyo}
      browserLocale={browserLocale}
      sessionToken={sessionToken}
      isStaticPage={isStaticPage}
    >
      {page}
    </LayoutProp>
  );
};

export default withCommonLayoutProps;
